import React, { memo } from 'react'
import { FieldErrors } from 'react-hook-form'
import ControlledTextArea from 'transfix-form/components/ControlledTextArea'
import { FormHelperText } from 'transfix-ui/components/FormHelperText'
import Grid from 'transfix-ui/core/Grid'
import { IEquipmentAttributeTypes } from 'types/graphqlTypes'
import { useCreateShipmentFormContext } from '../../../context'
import { TSpecializedEquipmentSchema } from '../../../schema/EquipmentDetailsSchema/EquipmentSpecializedSchema'
import { getEquipmentAttributeErrorMessage } from '../../../utils'

export interface ISpecializedEquipmentFormSectionProps {}

type TSpecializedSchemaErrors = FieldErrors<TSpecializedEquipmentSchema>

const SpecializedEquipmentFormSection = memo<ISpecializedEquipmentFormSectionProps>(() => {
  /**
   * Form Context
   */
  const { control, errors } = useCreateShipmentFormContext()
  const { equipmentAttributes } = errors || {}
  const equipmentAttributesErrors = equipmentAttributes as TSpecializedSchemaErrors

  const getErrorMessage = (keyName: keyof TSpecializedSchemaErrors) => {
    return getEquipmentAttributeErrorMessage<TSpecializedEquipmentSchema>(
      equipmentAttributesErrors,
      keyName
    )
  }

  return (
    <Grid container spacing={2} data-test='specialized-equipment-form-section'>
      <Grid item md={7}>
        <ControlledTextArea
          control={control}
          name={`equipmentAttributes.${IEquipmentAttributeTypes.specialized_description_details}`}
          TextAreaProps={{
            label: 'Equipment Description',
            placeholder: 'Please add any Specialized Equipment Description',
            dataTest: 'specialized-equipment-description',
            invalid: !!getErrorMessage(IEquipmentAttributeTypes.specialized_description_details),
            required: true,
          }}
        />
        <FormHelperText className='Mui-error'>
          {getErrorMessage(IEquipmentAttributeTypes.specialized_description_details)}
        </FormHelperText>
      </Grid>
    </Grid>
  )
})

export default SpecializedEquipmentFormSection
